"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const moment_1 = __importDefault(require("moment/moment"));
class AreaCertification {
    constructor(raw) {
        this.score = parseInt(raw.score + '');
        this.class = raw.class;
        this.location_text = raw.location_text;
        this.client_name = raw.client_name;
        this.areas = raw.areas;
        this.country = raw.country;
        this.province = raw.province;
        this.extension = parseInt(raw.extension + '');
        this.expires_at = (0, moment_1.default)(raw.expires_at).toDate();
        this.certified_at = (0, moment_1.default)(raw.certified_at).toDate();
        this.sample_type = raw.sample_type;
    }
}
exports.default = AreaCertification;
